<template>
  <home-layout>
    <v-card>
      <v-card-title>
        <h1>List of currencies</h1>
      </v-card-title>
      <v-card-text>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                      label="Search country"
                      v-model="stringSearch"
                    />
                  </v-flex>
                  <v-flex xs6>
                    <select-currency @change="setCompareCurrency" label="Set Currency Compare"/>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
            <v-flex xs12>
              <v-list two-line>
                <template v-for="(item, index) in items">
                  <v-list-tile avatar :key="index"
                    @click="$router.push(`/currencies/${item.label}`)" class="wow fadeIn">
                    <v-list-tile-avatar v-html="item.flag">
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{item.name}} - {{item.label}}</v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.value"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </home-layout>
</template>

<script>
import SelectCurrency from 'component/converter/SelectCurrency'
import currencyHelper from '../../helper/currency'

export default {
  components: {
    SelectCurrency
  },
  data: () => ({
    compareWithCurrency: 'USD',
    stringSearch: '',
    items: []
  }),
  computed: {
    currencies () {
      return currencyHelper.formartCurrencies(this.compareWithCurrency)
    }
  },
  watch: {
    stringSearch () {
      this.updateData()
    },
    compareWithCurrency () {
      this.updateData()
    }
  },
  methods: {
    setCompareCurrency (country) {
      this.compareWithCurrency = country
    },
    updateData () {
      let data = []
      for (let currency of this.currencies) {
        let str = this.stringSearch.toLowerCase()
        let nameOfCurrency = currency.name.toLowerCase()
        let labelOfCurrency = currency.label.toLowerCase()
        if (nameOfCurrency.indexOf(str) != -1 || labelOfCurrency.indexOf(str) != -1) {
          data.push(currency)
        }
      }
      this.items = data
    }
  },
  created () {
    this.items = this.currencies
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/currencies/index.vue